
import VueTypes from 'vue-types';
import { mapGetters } from 'vuex';

export default {
    name: 'MyCheckbox',
    props: {
        // Have to get certain data type
        value: VueTypes.any,
        type: VueTypes.any,
        label: VueTypes.any,
        modelValue: VueTypes.any,
        name: VueTypes.any,
        isEcom: VueTypes.any,
        isSubscribe: VueTypes.any,
        isValid: VueTypes.any,
        isFilter: VueTypes.any,
        isSimpleCheck: VueTypes.bool.def(false)
    },
    emits: ['change'],
    computed: {
        ...mapGetters({
            isCasaDelTabaco: 'global/getIsCasaDelTabaco'
        }),
        handledCheckValue() {
            return this.isSimpleCheck ? this.value : this.value === this.modelValue;
        }
    },
    methods: {
        updateModelValue() {
            this.$emit('change', this.value);
        }
    }
};
